import { render, staticRenderFns } from "./SlSpace.vue?vue&type=template&id=00ca3ac8&"
import script from "./SlSpace.vue?vue&type=script&lang=js&"
export * from "./SlSpace.vue?vue&type=script&lang=js&"
import style0 from "./SlSpace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports